export class GlobalContextQuery {
    constructor() {
        this.content = "";
        this.updated_q = "";
    }
}
export class GlobalContextData {
    constructor() {
        this.query = [];
    }
}
